import { createApiHooks } from '@apis/next/common';
import { Vessel } from '@models/next/Vessel';
import { z } from 'zod';

export const dashboardVesselApis = createApiHooks('/dashboard', [
  {
    method: 'get',
    path: '/vessel',
    parameters: [
      {
        type: 'Query',
        name: 'callsign',
        schema: z.string().optional(),
      },
      {
        type: 'Query',
        name: 'vessel',
        schema: z.string().optional(),
      },
    ],
    response: Vessel.array(),
  },
]);
